import { apiRootUrl } from '../assets/constants';
import { showApiErrorAlert } from '../functions/api';

type RoomMemberType = {
    userId: number,
    userName: string
};

type RoomTopicType = {
    body: string,
    commentCount: number,
    openRange: number
    postStatus: number,
    postTime: string,
    title: string,
    topicId: number,
    topicMembers: null | {
        email: string,
        userId: number,
        userName: string,
    }[],
    updatedTime: string,
    userId: number,
    userName: string,
}

// ルームメンバー一覧の取得
export const getRoomMembers = (roomId: string | undefined): Promise<RoomMemberType[] | void> => {
    const api = apiRootUrl + "/rooms/members/" + roomId;
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "ルームメンバーの取得");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            return result.data;
        })
        .catch((error) => {
            console.log(error);
        });
};

// ルームトピック一覧の取得
export const getRoomTopics = (roomId: string, userId: number): Promise<RoomTopicType[] | void> => {
    const api = apiRootUrl + "/rooms/topics/" + roomId + "/" + userId;
    const options = {
        method: "GET",
    }
    return fetch(api, options)
        .then((response) => response.json())
        .then((result) => {
            // アラート表示
            if (result.status === 500) {
                showApiErrorAlert(result.status, "トピック一覧の取得");
            }
            // エラー処理
            if (result.status !== 200) {
                throw new Error(result.status);
            }
            // 成功処理
            if (result.status === 200) {
                return result.data;
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
